export default __webpack_public_path__ + "static/media/dl.5a7d3354.svg";